import { useState } from "react";
import { Loader2, Pencil } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg, useApi } from "@/lib/api";

const inp = "w-full h-11 px-3 rounded-xl bg-bg border border-line text-sm focus:outline-none focus:border-[var(--q)]";
const F = [["tajuk", "Tajuk Program"], ["peserta", "Jenis Peserta"], ["tempoh", "Tempoh Program"]];

export const MetaEditor = ({ kajian, onChange }) => {
  const api = useApi();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const start = () => { setF({ tajuk: kajian.program.tajuk, peserta: kajian.program.peserta, tempoh: kajian.program.tempoh }); setOpen(true); };
  const save = async () => {
    setBusy(true);
    try {
      await api("patch", `/hte/kajian/${kajian.id}/program`, f);
      onChange({ tajuk: f.tajuk, program: { ...kajian.program, ...f } }); toast.success("Maklumat program dikemas kini"); setOpen(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={start} data-testid="program-meta-edit" className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-2 hover:bg-surface"><Pencil size={14} /> Sunting maklumat</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="program-meta-dialog">
          <DialogHeader><DialogTitle>Sunting maklumat program</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {F.map(([k, l]) => (
              <label key={k} className="block"><span className="eyebrow block mb-1">{l}</span>
                <input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={inp} data-testid={`program-meta-${k}`} /></label>
            ))}
            <button onClick={save} disabled={busy || (f.tajuk || "").trim().length < 3 || (f.peserta || "").trim().length < 2 || !(f.tempoh || "").trim()} data-testid="program-meta-save"
              className="h-10 px-5 rounded-full bg-ink text-bg text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-40">{busy && <Loader2 size={14} className="animate-spin" />} Simpan</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
